import SingleUserInfoComponent from './SingleUserInfoComponent';

export default SingleUserInfoComponent;
